import { combineReducers } from "redux";
import { courses } from "./courses";
export default combineReducers({
  courses,
});
